/**
 * Blue Shield of California Custom Components
 *
 * This file exports all custom components for Blue Shield of California
 */

import CustomLoadingIndicator from './CustomLoadingIndicator';
import CustomProgressIndicator from './CustomProgressIndicator';
import CustomFormControlOption from './CustomFormControlOption';
import CustomHeader from './CustomHeader';
import CustomButton from './CustomButton';
import CustomResourceButton from './CustomResourceButton';
import CustomErrorMessage from './CustomErrorMessage';
import CustomSelect from './CustomSelect';
import CustomActionButtons from './CustomActionButtons';
import CustomTitle from './CustomTitle';
import CustomResumeOverlay from './CustomResumeOverlay';
import CustomEmailResultsModal from './CustomEmailResultsModal';
import CustomEmailResultsButton from './CustomEmailResultsButton';
import CarouselLeftArrow from './icons/CarouselLeftArrow';
import CarouselRightArrow from './icons/CarouselRightArrow';
import { themeConfig } from './themeConfig';
import componentStyles, { getComponentStyles } from './componentStyles';
import layoutConfig from './layoutConfig';

// Override registry for Blue Shield components
const componentOverrides = {
  Header: CustomHeader,
  ProgressIndicator: CustomProgressIndicator,
  FormControlOption: CustomFormControlOption,
  Button: CustomButton,
  ResourceButton: CustomResourceButton,
  Title: CustomTitle,
  ResumeOverlay: CustomResumeOverlay,
  styles: componentStyles,
};

/**
 * Export custom components and configuration objects
 */
export {
  CustomLoadingIndicator,
  CustomProgressIndicator,
  CustomFormControlOption,
  CustomButton,
  CustomHeader,
  CustomResourceButton,
  CustomErrorMessage,
  CustomActionButtons,
  CustomTitle,
  CustomEmailResultsModal,
  CustomEmailResultsButton,
  themeConfig,
  layoutConfig,
  componentOverrides,
  componentStyles,
  getComponentStyles,
  CustomSelect,
  CustomResumeOverlay,
  CarouselLeftArrow,
  CarouselRightArrow,
};
